module.exports = __webpack_public_path__ + "assets/img/banner-14.c2e2d1ee.jpg";